import { useEffect, useState } from "react";
import { Palette, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

type ColorTheme = "default" | "emerald" | "graphite" | "bordo" | "violet" | "lightBlue";

const THEMES: { id: ColorTheme; label: string; swatch: [string, string] }[] = [
  { id: "default", label: "Niebieski + złoto", swatch: ["#2a5a8c", "#e8c860"] },
  { id: "emerald", label: "Zieleń + złoto", swatch: ["#155e44", "#e8c860"] },
  { id: "graphite", label: "Grafit + miedź", swatch: ["#2b2e33", "#c87f4a"] },
  { id: "bordo", label: "Bordo + złoto", swatch: ["#6b1f38", "#e8c860"] },
  { id: "violet", label: "Fiolet + srebro", swatch: ["#3d2a66", "#9b9bc0"] },
  { id: "lightBlue", label: "Jasny biało-niebieski", swatch: ["#ffffff", "#0d5c78"] },
];

const STORAGE_KEY = "color-theme";

export const applyStoredColorTheme = () => {
  const stored = (localStorage.getItem(STORAGE_KEY) as ColorTheme) || "default";
  if (stored === "default") {
    document.documentElement.removeAttribute("data-theme");
  } else {
    document.documentElement.setAttribute("data-theme", stored);
  }
};

const ColorThemeSwitcher = () => {
  const [theme, setTheme] = useState<ColorTheme>(
    () => (typeof window !== "undefined" && (localStorage.getItem(STORAGE_KEY) as ColorTheme)) || "default"
  );

  useEffect(() => {
    if (theme === "default") {
      document.documentElement.removeAttribute("data-theme");
    } else {
      document.documentElement.setAttribute("data-theme", theme);
    }
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label="Zmień profil kolorów"
        className="nav-control-trigger transition-colors p-2 rounded-md"
      >
        <Palette className="w-[1.125rem] h-[1.125rem]" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        {THEMES.map((t) => (
          <DropdownMenuItem
            key={t.id}
            onClick={() => setTheme(t.id)}
            className="flex items-center gap-2 cursor-pointer"
          >
            <span className="flex gap-1">
              <span className="w-3.5 h-3.5 rounded-full border border-border" style={{ backgroundColor: t.swatch[0] }} />
              <span className="w-3.5 h-3.5 rounded-full border border-border" style={{ backgroundColor: t.swatch[1] }} />
            </span>
            <span className="flex-1 text-sm">{t.label}</span>
            {theme === t.id && <Check className="w-4 h-4 text-accent" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ColorThemeSwitcher;
